import React, { useState, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { getAllData, getAllFilterData } from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { Col, Row, Container } from "react-bootstrap";

import successicon from "../../../assests/payments_icon/success.png";
import pendingicon from "../../../assests/payments_icon/pending.png";
import canceicon from "../../../assests/payments_icon/cancel.png";
import CashDetails from "./cashDetails";
import CardDetails from "./cardDetails";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const CardWithDrawal = () => {
  const userInfo = useSelector((state) => state.auth);

  const [rows, setRows] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalcount, setTotalCount] = useState(1);

  const [userId, setUserId] = useState("");
  const [Transtype, setTransType] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");

  const [email,setEmail]= useState("")

  const [detailsModal, setDetailModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});

  const emptyRows = 0;

  useEffect(() => {
    paymentsData(1, filteredData);
  }, []);

  // withdrawl payments get api call
  const paymentsData = async (page, data) => {
    let url = `${endPoints.api.WITHDRAW_CARD_TRANSACTIONS}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);
          const ITEMS_PER_PAGE = rowsPerPage;
          setTotalCount(data[0]?.totalcount);
          const totalCount = data[0]?.totalcount;
          const totalPagesCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
          setTotalPages(totalPagesCount);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    paymentsData(newPage + 1, filteredData);
  };

  const handleChangeRowsPerPage = (event, newPage) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
  };

  useEffect(() => {
    paymentsData(page, filteredData);
  }, [rowsPerPage]);

  let filteredData = {
    userId: userId,
    status: Transtype,
    name: name,
    userName: username,
    email:email
  };

  return (
    <>
      <div>
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div style={{ marginTop: "10px" }}>
                <Row>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Customer ID</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Customer ID"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter First Name or Last Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Userrname</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Username"
                        value={username}
                        onChange={(e) => setuserName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Email</Form.Label>
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">
                        Withdrawal Status
                      </Form.Label>
                      <Form.Select
                        onChange={(e) => setTransType(e.target.value)}
                      >
                        <option value="" disabled selected>
                          Select Withdrawal Status
                        </option>
                        <option value="1">Approved</option>
                        <option value="0">Pending</option>
                        <option value="2">Hold</option>
                        <option value="3">Cancelled</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group
                      as={Col}
                      controlId="formName"
                      style={{ marginTop: "30px" }}
                    >
                      <Button
                        variant="primary"
                        style={{
                          width: "70%",
                          background: "#0D3862",
                          borderRadius: "8px",
                        }}
                        onClick={() => paymentsData(1, filteredData)}
                      >
                        Search
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
                {/* </div> */}
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Customer ID</TableCell>
                            <TableCell align="center">Username</TableCell>
                           
                            <TableCell align="center">
                             Name
                            </TableCell>
                            <TableCell align="center">VIP Label </TableCell>
                            <TableCell align="center">Trans Date</TableCell>
                            <TableCell align="center"> Deposit </TableCell>
                               <TableCell align="center"> Settled </TableCell>
                            <TableCell align="center">
                             Withdrawal
                            </TableCell>
                            <TableCell align="center"> Redeem</TableCell>
                            <TableCell align="center">
                            Pending Count
                            </TableCell>
                          
                         
                            <TableCell align="center">Amount</TableCell>
                            <TableCell align="center">
                              Withdrawal Status
                            </TableCell>
                            <TableCell align="center">Account Status</TableCell>

                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                              style={{
                              background : row.totalDeposit?.toFixed(2) === row.totalSetlledDeposit?.toFixed(2)  ? 'white' : '#f27c7c'
                              }}
                            >
                              <TableCell align="center">
                                {row.id_user}
                              </TableCell>
                              <TableCell align="center">{row.login}</TableCell>
                             
                              <TableCell align="center">
                                {row.name} {row.surname}
                              </TableCell>
                              <TableCell align="center">{row.vipLavel}</TableCell>
                          
                              <TableCell align="center">
                                {moment
                                  .utc(row.insertion_time)
                                  .format("YYYY-MM-DD")}
                              </TableCell>
                              <TableCell align="center">
                               ${row.totalDeposit?.toFixed(2)}
                              </TableCell>
                                <TableCell align="center">
                               ${row.totalSetlledDeposit?.toFixed(2)}
                              </TableCell>
                              <TableCell align="center">
                                ${row.totalWidhdrawl}
                              </TableCell>
                              <TableCell align="center">
                                  ${row?.totalRedeem?.toFixed(2)}
                                </TableCell>
                              <TableCell align="center">
                                {row.totalWidhdrawlPending}
                              </TableCell>
                             
                              <TableCell align="center">
                                ${row.tamount}
                              </TableCell>
                              <TableCell align="center">
                                {row.transaction_status}
                              </TableCell>

                              <TableCell align="center">
                                {row.accountSatus}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="mrglft10"
                                  style={{
                                    background: "#0D3862",
                                    borderRadius: "8px",
                                    fontSize: "9px",
                                    fontWeight: "bold",
                                  }}
                                  onClick={() => {
                                    setDetailModal(true);
                                    setSelectedRecord(row);
                                  }}
                                >
                                 More Redeem
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              className="hide-rows-per-page-options"
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              colSpan={12}
                              count={
                                rowsPerPage === -1 ? rows.length : totalcount
                              }
                              rowsPerPage={rowsPerPage}
                              page={page - 1}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={detailsModal}
        onHide={() => {
          setDetailModal(false);
        }}
        fullscreen
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Redemption Claims Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <RedemDetails selectedRecord={selectedRecord} /> */}
          <CardDetails selectedRecord={selectedRecord} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CardWithDrawal;
